



/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// getAllPendingPurchasesWithCreator
// GETALLPENDINGPURCHASESWITHCREATOR


const GETALLPENDINGPURCHASESWITHCREATOR= createAsyncThunk(
  "getAllPendingPurchasesWithCreator/getAllPendingPurchasesWithCreator",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getAllPendingPurchasesWithCreatorSlice = createSlice({
  name: "getAllPendingPurchasesWithCreatorSlice",
  initialState: {
    getAllPendingPurchasesWithCreator: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetAllPendingPurchasesWithCreator: (state) => {
        state.getAllPendingPurchasesWithCreator.loading = false
        state.getAllPendingPurchasesWithCreator.error = false
        state.getAllPendingPurchasesWithCreator.data = []
        state.getAllPendingPurchasesWithCreator.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETALLPENDINGPURCHASESWITHCREATOR.fulfilled, (state, action) => {
      state.getAllPendingPurchasesWithCreator = {
        ...state.getAllPendingPurchasesWithCreator,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLPENDINGPURCHASESWITHCREATOR.pending, (state, action) => {
      state.getAllPendingPurchasesWithCreator = {
        ...state.getAllPendingPurchasesWithCreator,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLPENDINGPURCHASESWITHCREATOR.rejected, (state, action) => {
      state.getAllPendingPurchasesWithCreator = {
        ...state.getAllPendingPurchasesWithCreator,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getAllPendingPurchasesWithCreatorAction = {
    GETALLPENDINGPURCHASESWITHCREATOR,
};

export { getAllPendingPurchasesWithCreatorAction };
export default getAllPendingPurchasesWithCreatorSlice.reducer;
export const {setInitialStateOfgetAllPendingPurchasesWithCreator} = getAllPendingPurchasesWithCreatorSlice.actions
